"use strict";
/**
 * Created on 02 28 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>Segment specific base (without real sales) input to calculate price impact of an release item, can be used for both regular and
 * sellout releases. For regular releases segment is represented by price zone, for sellout release it is particular site.</p>
 *
 * @author JMe
 */


var ReleaseItemEvaluationInput =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleaseItemEvaluationInput, _DomainObject_1$Domai);

  /**
   * Ctor (minimized attributes length due to possible serialization to DB -> saves memory, saves time).
   * <br/>
   * Each attribute should be exaggeratedly described.
   *
   * @param sId Segment id. Depends on release type, may represent zone id (regular release) or site id (sellout release).
   * @param rId Identification of the associated release.
   * @param iId Identification of the associated item.
   * @param pId Identification of the associated product.
   * @param exp Indicates whether the item has been actually exported, true if yes, false otherwise. In case of regular releases, value
   *        is not segment (zone) specific.
   * @param vFrom Price validity start (should include possible repricing constraints).
   * @param vTo Price validity end. If not filled within source data, configured constant representing infinite date is used instead.
   * @param mOld Expected margin for old (current) price (see desc. within source data for more info).
   *        If not filled within source data, zero value is used.
   * @param mNew Expected margin for new (suggested) price (see desc. within source data for more info).
   *        If not filled within source data, zero value is used.
   * @param pOld Expected profit for old (current) price (see desc. within source data for more info).
   *        If not filled within source data, zero value is used.
   * @param pNew Expected profit for new (suggested) price (see desc. within source data for more info).
   *        If not filled within source data, zero value is used.
   * @param vA Vendor allowance bonus (value is percentage number). If not filled within source data, zero value is used. Vendor allowance
   *        value may not be specific to segment, but for simplicity, modeled as segment specific.
   * @param fOld Forecast amount for one day for old price.
   *        If not filled within source data, zero value is used.
   * @param fNew Forecast amount for one day for new price.
   *        If not filled within source data, zero value is used.
   * @param rP Current (regular) price value. If not filled within source data, zero value is used.
   * @param rPVatRate VAT rate for current (regular) price. If not filled within source data, zero value is used.
   */
  function ReleaseItemEvaluationInput(sId, rId, iId, pId, exp, vFrom, vTo, mOld, mNew, pOld, pNew, vA, fOld, fNew, rP, rPVatRate) {
    var _this;

    _classCallCheck(this, ReleaseItemEvaluationInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemEvaluationInput).call(this));
    _this.sId = sId;
    _this.rId = rId;
    _this.iId = iId;
    _this.pId = pId;
    _this.exp = exp;
    _this.vFrom = vFrom;
    _this.vTo = vTo;
    _this.mOld = mOld;
    _this.mNew = mNew;
    _this.pOld = pOld;
    _this.pNew = pNew;
    _this.vA = vA;
    _this.fOld = fOld;
    _this.fNew = fNew;
    _this.rP = rP;
    _this.rPVatRate = rPVatRate;
    return _this;
  }

  return ReleaseItemEvaluationInput;
}(DomainObject_1.DomainObject);

exports.ReleaseItemEvaluationInput = ReleaseItemEvaluationInput;